import { firstValueFrom } from 'rxjs';
import { AuthenticationService } from './shared/services/application/authentication.service';
import { CommonService } from './shared/services/application/common.service';
import { SocialService } from './shared/services/application/social.service';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@meplis/common';

export function appInitializer(
  authService: AuthenticationService,
  commonService: CommonService,
  socialService: SocialService,
  translateService: TranslateService
): () => Promise<void> {
  return async (): Promise<void> => {
    const currentLanguages = Object.values(Language);

    translateService.addLangs(currentLanguages);
    translateService.setFallbackLang('en');

    if (commonService.isPlatformBrowser) {
      const browserLang = translateService.getBrowserLang();

      const langRegex = new RegExp(currentLanguages.join('|'), 'g');

      const langToUse =
        browserLang && langRegex.test(browserLang) ? browserLang : 'en';

      try {
        await firstValueFrom(translateService.use(langToUse));
      } catch {
        await firstValueFrom(translateService.use('en'));
      }

      try {
        await authService.verifyIfIsLoggedIn();

        if (authService.isLogged) {
          // Warm the user-instance cache without blocking bootstrap. The app can
          // paint immediately after auth is resolved; the instance arrives a
          // moment later and components react via onUserInstanceChanged().
          socialService.loadData().subscribe({
            error: (error) =>
              console.warn(
                'appInitializer: socialService.loadData failed',
                error
              ),
          });
        }
      } catch (error) {
        console.warn('appInitializer: verifyIfIsLoggedIn failed', error);
      }
    } else {
      try {
        await firstValueFrom(translateService.use('en'));
        console.log(
          'SSR translations loaded:',
          translateService.instant('EVENTS.TITLE')
        );
      } catch (error) {
        console.warn('Failed loading SSR translations');
        console.error('SSR translation failed', error);
      }
    }
  };
}
